/* eslint-disable no-restricted-syntax */
import { cts_secure } from '../app/cts';
import apis from '../app/apis';

const getCollection = async (projectId, districtId, zone, lang) => {
  try {
    const { data, status } = await cts_secure('get', apis.getCollectionJson(projectId, districtId, zone, lang));

    if (
      !data
      || status !== 200
    ) throw new Error('Error getting collection details');

    const { collection } = data;
    for (const key in collection.types) {
      if (collection.types[key].iconicShape === null) {
        collection.types[key].iconicShape = 'simple_bin';
      }
    }
    return Promise.resolve(collection.types);
  } catch ({ message }) {
    return Promise.reject(message);
  }
};

export default getCollection;
